import { getUserDisplayName } from '../aifeatures/utils'
import { User, UserShareSettings } from '../../../../../models/User'
import { UserFilterType } from './hooks'

export const transformUserFilter = (
  currentUserId: string,
  sessionSharingAvailable: boolean,
  filterType: UserFilterType,
  users?: User[],
  shares?: UserShareSettings[],
) => {
  if (!users || !shares) {
    return []
  }

  const meUserFilterOption = { label: 'Me', id: currentUserId }
  const allUsersFilterOption = { label: 'All', id: '{all}' }

  const otherUsers = users
    .filter((u) => {
      return u.id !== currentUserId && shares.map((s) => s.ownerUserId).includes(u.id)
    })
    .map((u) => ({ id: u.id, label: getUserDisplayName(u) }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return [...(sessionSharingAvailable ? [allUsersFilterOption] : []), ...(filterType !== 'live' ? [meUserFilterOption] : []), ...otherUsers]
}
